import { createContext, useContext } from "react";

export const LangContext = createContext({ lang: "fr", setLang: () => {} });
export const useLang = () => {
  const { lang, setLang } = useContext(LangContext);
  return { lang, setLang, t: dict[lang] };
};

const fr = {
  nav: { benefits: "Bienfaits", origin: "Origine", use: "Mode d'emploi", faq: "FAQ", order: "Commander" },
  hero: {
    kicker: "Électrolytes liquides · 240 ml · 160 portions",
    lines: ["L'océan austral,", "goutte", "à goutte."],
    sub: "Plus de 70 minéraux ioniques issus de l'eau de mer d'Australie-Méridionale, concentrée au soleil et allégée en sodium. Sans sucre, sans arôme, sans additif.",
    cta: "S'enregistrer pour commander",
    cta2: "Découvrir la formule",
    ship: "Livraison France & Polynésie française via enregistrement",
    angles: ["Face", "Gauche", "Droite"],
    badges: ["Minéraux traces", "Sans sucre", "Sans gluten", "Keto", "Sans OGM", "Carnivore", "Vegan", "Casher Parvé"],
    price: "29,99 USD",
    priceNote: "prix indicatif du site officiel",
  },
  stats: { per: "par portion de 20 gouttes", items: ["Magnésium", "Potassium", "Sodium", "Chlorure", "Minéraux traces"] },
  band: "De l'océan austral à votre verre, sans rien entre les deux.",
  marquee: ["Eau de mer concentrée au soleil", "70+ minéraux ioniques", "Zéro sucre", "Allégé en sodium", "Compatible jeûne & keto", "Vegan · Sans gluten · Sans OGM"],
  bento: {
    kicker: "01 — Bienfaits",
    title: "L'hydratation, ce n'est pas boire. C'est absorber.",
    items: [
      { t: "Hydratation rapide et durable", d: "Des minéraux sous forme ionique, reconnus immédiatement par vos cellules, pour une hydratation que l'on ressent et qui tient toute la journée." },
      { t: "Riche en magnésium", d: "102 mg de magnésium élémentaire par portion, impliqué dans plus de 300 processus enzymatiques." },
      { t: "Récupération & équilibre", d: "Potassium et chlorure pour la contraction musculaire, l'influx nerveux et l'équilibre hydrique." },
      { t: "Rien d'artificiel", d: "Ni sucre, ni édulcorant, ni colorant, ni conservateur. Ne rompt pas le jeûne." },
      { t: "Partout avec vous", d: "Maison, bureau, salle de sport ou voyage : quelques gouttes suffisent." },
    ],
    dropLabel: "gouttes",
    dropHint: "Touchez pour ajouter une goutte",
  },
  origin: {
    kicker: "02 — Ingrédients & origine",
    title: "Un seul ingrédient. Soixante-dix minéraux.",
    body: "Récoltée sur la côte préservée de l'Australie-Méridionale, l'eau de mer est concentrée uniquement par le soleil, puis allégée en sodium. Il en résulte une solution de minéraux traces ioniques, naturellement riche en magnésium, qui contient plus de 70 minéraux et oligo-éléments essentiels.",
    ingredientLabel: "Ingrédient",
    ingredient: "Eau de mer australienne concentrée au soleil, allégée en sodium.",
    steps: [
      { n: "Récolte", d: "Eau de mer pure de la côte sud australienne." },
      { n: "Soleil", d: "Concentration 100 % solaire, sans procédé chimique." },
      { n: "Équilibre", d: "Réduction du sodium pour un profil minéral harmonieux." },
    ],
    balanceTitle: "La synergie avant tout",
    balance: "Les minéraux fonctionnent en équipe. Isoler un seul minéral à forte dose peut perturber l'équilibre ; les apporter ensemble, dans les ratios de la nature, maximise leur efficacité.",
  },
  use: {
    kicker: "03 — Mode d'emploi",
    title: "Trois gestes, une journée hydratée.",
    steps: [
      "Ajoutez jusqu'à 20 gouttes (1,5 ml) dans 500 à 1000 ml d'eau ou de boisson.",
      "Buvez régulièrement tout au long de la journée pour une hydratation et une minéralisation optimales.",
      "Profitez de l'énergie d'une hydratation complète. Un goût ? Diluez davantage.",
    ],
    calcTitle: "Calculateur de dosage",
    calcLabel: "Volume d'eau",
    calcResult: "gouttes recommandées (max.)",
  },
  compare: {
    kicker: "04 — Comparatif",
    title: "Tous les électrolytes ne se valent pas.",
    us: "Aussie Trace Minerals",
    them: "Autres marques",
    rows: [
      { k: "Spectre minéral", a: "Plus de 70 minéraux ioniques en ratios naturels", b: "Mélanges riches en sodium, 2 à 3 électrolytes seulement" },
      { k: "Biodisponibilité", a: "Minéraux ioniques, absorption immédiate", b: "Sels synthétiques à faible assimilation" },
      { k: "Pureté", a: "Zéro sucre, édulcorant ou conservateur", b: "Mélanges sucrés, arômes artificiels, charges" },
      { k: "Format", a: "Gouttes faciles à doser, idéales en voyage", b: "Poudres salissantes, mélange inégal" },
    ],
  },
  order: {
    kicker: "05 — Commander",
    title: "Enregistrez votre adresse, on s'occupe du reste.",
    body: "Le site officiel ne livre pas directement en France ni en Polynésie française. Enregistrez-vous d'abord avec votre adresse de livraison complète : elle nous permet d'organiser l'acheminement de votre commande.",
    fields: { first_name: "Prénom", last_name: "Nom", email: "E-mail", phone: "Téléphone (facultatif)", address: "Adresse", address2: "Complément d'adresse (facultatif)", city: "Ville / Commune / Île", postal_code: "Code postal", country: "Pays / Territoire", notes: "Précisions de livraison (facultatif)" },
    countries: { "France": "France", "Polynésie française": "Polynésie française", "Autre": "Autre" },
    consent: "J'accepte que mes coordonnées soient utilisées pour organiser la livraison de ma commande.",
    submit: "M'enregistrer et débloquer l'achat",
    sending: "Enregistrement…",
    required: "Merci de remplir tous les champs obligatoires et d'accepter la condition.",
    successTitle: "Merci {name}, vous êtes enregistré(e).",
    successBody: "Votre adresse de livraison est bien reçue. Vous pouvez maintenant finaliser votre achat sur la boutique officielle.",
    buy: "Acheter sur la boutique officielle",
    reset: "Enregistrer une autre adresse",
    product: "Électrolytes liquides complets · 240 ml",
    steps: ["Enregistrement", "Achat officiel", "Livraison"],
  },
  faq: {
    kicker: "06 — Questions fréquentes",
    title: "Vos questions, nos réponses.",
    items: [
      { q: "Pourquoi dois-je m'enregistrer avant d'acheter ?", a: "La boutique officielle ne livre pas directement en France ni en Polynésie française. Votre adresse de livraison nous permet d'organiser l'acheminement de votre commande jusqu'à vous." },
      { q: "Quel goût cela a-t-il ?", a: "Le produit est non aromatisé. Bien dilué, il est pratiquement sans goût. Si vous percevez un goût, diluez simplement davantage." },
      { q: "Combien de temps dure un flacon ?", a: "Le flacon de 240 ml contient environ 160 portions de 20 gouttes (1,5 ml)." },
      { q: "Est-ce compatible avec le jeûne ou le régime keto ?", a: "Oui. Sans sucre ni calories ajoutées, il ne rompt pas le jeûne et s'intègre aux routines keto, carnivore ou vegan." },
      { q: "Que contient exactement le produit ?", a: "Un seul ingrédient : de l'eau de mer australienne concentrée au soleil et allégée en sodium. Par portion : 102 mg de magnésium, 45 mg de potassium, 39 mg de sodium et 335 mg de chlorure." },
      { q: "Dans quoi puis-je le mélanger ?", a: "Dans l'eau ou toute autre boisson. Il se fond sans altérer le goût lorsqu'il est suffisamment dilué." },
    ],
  },
  news: {
    title: "Restez hydraté(e), restez informé(e).",
    body: "Recevez nos conseils d'hydratation et les nouvelles arrivées. Pas de spam, désinscription en un clic.",
    placeholder: "votre@email.com",
    submit: "S'inscrire",
    ok: "Merci ! Vous êtes inscrit(e).",
    bad: "Adresse e-mail invalide.",
  },
  footer: {
    note: "Mareia est un site partenaire indépendant. Les achats sont finalisés sur la boutique officielle Aussie Trace Minerals via un lien d'affiliation.",
    disclaimer: "Ces informations ne remplacent pas l'avis d'un professionnel de santé.",
    admin: "Espace admin",
  },
};

const en = {
  nav: { benefits: "Benefits", origin: "Origin", use: "How to use", faq: "FAQ", order: "Order" },
  hero: {
    kicker: "Liquid electrolytes · 240 ml · 160 servings",
    lines: ["The Southern Ocean,", "drop", "by drop."],
    sub: "Over 70 ionic minerals from South Australian ocean water, solar-concentrated and sodium-reduced. No sugar, no flavour, no additives.",
    cta: "Register to order",
    cta2: "Explore the formula",
    ship: "Delivery to France & French Polynesia via registration",
    angles: ["Front", "Left", "Right"],
    badges: ["Trace minerals", "Sugar free", "Gluten free", "Keto", "Non GMO", "Carnivore", "Vegan", "Kosher Pareve"],
    price: "$29.99 USD",
    priceNote: "indicative price from the official store",
  },
  stats: { per: "per 20-drop serving", items: ["Magnesium", "Potassium", "Sodium", "Chloride", "Trace minerals"] },
  band: "From the Southern Ocean to your glass, with nothing in between.",
  marquee: ["Solar-concentrated ocean water", "70+ ionic minerals", "Zero sugar", "Sodium reduced", "Fasting & keto friendly", "Vegan · Gluten free · Non-GMO"],
  bento: {
    kicker: "01 — Benefits",
    title: "Hydration isn't drinking. It's absorbing.",
    items: [
      { t: "Fast & sustained hydration", d: "Minerals in ionic form, recognised instantly by your cells, for hydration you can feel that lasts all day." },
      { t: "Magnesium-rich", d: "102 mg of elemental magnesium per serving, supporting over 300 enzymatic processes." },
      { t: "Recovery & balance", d: "Potassium and chloride for muscle contraction, nerve signalling and fluid balance." },
      { t: "Nothing artificial", d: "No sugar, sweeteners, colours or preservatives. Won't break a fast." },
      { t: "Goes everywhere", d: "Home, office, gym or travel: a few drops are all it takes." },
    ],
    dropLabel: "drops",
    dropHint: "Tap to add a drop",
  },
  origin: {
    kicker: "02 — Ingredients & origin",
    title: "One ingredient. Seventy minerals.",
    body: "Harvested from the pristine Southern Australian coast, the ocean water is concentrated by the sun alone, then sodium-reduced. The result is a pure ionic trace mineral solution, naturally rich in magnesium, containing over 70 essential minerals and trace elements.",
    ingredientLabel: "Ingredient",
    ingredient: "Solar-concentrated, sodium-reduced Australian ocean water.",
    steps: [
      { n: "Harvest", d: "Pure ocean water from the Southern Australian coast." },
      { n: "Sun", d: "100% solar concentration, no chemical process." },
      { n: "Balance", d: "Sodium reduced for a harmonious mineral profile." },
    ],
    balanceTitle: "Synergy first",
    balance: "Minerals work as a team. Isolating one mineral at high doses can disrupt balance; delivering them together, in nature's ratios, maximises their effectiveness.",
  },
  use: {
    kicker: "03 — How to use",
    title: "Three steps, one hydrated day.",
    steps: [
      "Add up to 20 drops (1.5 ml) to 500–1000 ml of water or any beverage.",
      "Drink frequently throughout the day for optimal hydration and mineralisation.",
      "Enjoy the energy of complete hydration. Taste it? Simply dilute more.",
    ],
    calcTitle: "Dosage calculator",
    calcLabel: "Water volume",
    calcResult: "recommended drops (max.)",
  },
  compare: {
    kicker: "04 — Comparison",
    title: "Not all electrolytes are created equal.",
    us: "Aussie Trace Minerals",
    them: "Other brands",
    rows: [
      { k: "Mineral spectrum", a: "Over 70 ionic minerals in natural ratios", b: "Sodium-heavy blends with only 2–3 electrolytes" },
      { k: "Bioavailability", a: "Ionic minerals for immediate absorption", b: "Synthetic salts with poor uptake" },
      { k: "Purity", a: "Zero sugar, sweeteners or preservatives", b: "Sugary mixes, artificial flavours, fillers" },
      { k: "Format", a: "Easy-to-dose drops, travel-friendly", b: "Messy powders, inconsistent mixing" },
    ],
  },
  order: {
    kicker: "05 — Order",
    title: "Register your address, we handle the rest.",
    body: "The official store does not ship directly to France or French Polynesia. Please register first with your full delivery address: it lets us arrange the forwarding of your order.",
    fields: { first_name: "First name", last_name: "Last name", email: "Email", phone: "Phone (optional)", address: "Address", address2: "Address line 2 (optional)", city: "City / Town / Island", postal_code: "Postal code", country: "Country / Territory", notes: "Delivery notes (optional)" },
    countries: { "France": "France", "Polynésie française": "French Polynesia", "Autre": "Other" },
    consent: "I agree that my details are used to arrange the delivery of my order.",
    submit: "Register & unlock purchase",
    sending: "Registering…",
    required: "Please fill in all required fields and accept the condition.",
    successTitle: "Thank you {name}, you're registered.",
    successBody: "Your delivery address has been received. You can now complete your purchase on the official store.",
    buy: "Buy on the official store",
    reset: "Register another address",
    product: "Complete liquid electrolytes · 240 ml",
    steps: ["Register", "Official purchase", "Delivery"],
  },
  faq: {
    kicker: "06 — FAQ",
    title: "Your questions, answered.",
    items: [
      { q: "Why do I need to register before buying?", a: "The official store does not ship directly to France or French Polynesia. Your delivery address lets us arrange the forwarding of your order to you." },
      { q: "What does it taste like?", a: "It is unflavoured. Properly diluted, it is virtually tasteless. If you notice a taste, simply dilute more." },
      { q: "How long does a bottle last?", a: "The 240 ml bottle holds about 160 servings of 20 drops (1.5 ml)." },
      { q: "Is it fasting or keto friendly?", a: "Yes. With no sugar or added calories, it won't break a fast and fits keto, carnivore or vegan routines." },
      { q: "What exactly is in it?", a: "A single ingredient: solar-concentrated, sodium-reduced Australian ocean water. Per serving: 102 mg magnesium, 45 mg potassium, 39 mg sodium and 335 mg chloride." },
      { q: "What can I mix it with?", a: "Water or any other beverage. It blends in without altering taste when diluted enough." },
    ],
  },
  news: {
    title: "Stay hydrated, stay informed.",
    body: "Get our hydration tips and new arrivals. No spam, unsubscribe in one click.",
    placeholder: "you@email.com",
    submit: "Subscribe",
    ok: "Thanks! You're subscribed.",
    bad: "Invalid email address.",
  },
  footer: {
    note: "Mareia is an independent partner site. Purchases are completed on the official Aussie Trace Minerals store via an affiliate link.",
    disclaimer: "This information does not replace advice from a healthcare professional.",
    admin: "Admin area",
  },
};

export const dict = { fr, en };
